export default {
  navigationBarTitleText: '全部提现'
};
